import {
    GET_MONITORING_MISSING_TREATMENT_SESSIONS
} from '../actions/types';

const INIT_STATE = {
    treatment_missing: {
        items: [],
        pagination: {
            currentPage: 1,
            perPage: 20,
            total: 0
        }
    }

    // 🔜 future:
    // schedule_missing: {}
    // labo_pending: {}
    // payment_pending: {}
};

export default function monitoringReducer(state = INIT_STATE, action) {
    switch (action.type) {

        case GET_MONITORING_MISSING_TREATMENT_SESSIONS: {
            const data = action.payload || {};

            return {
                ...state,
                treatment_missing: {
                    items: data.items || [],
                    pagination: {
                        currentPage: Number(data.page) || 1,
                        perPage: Number(data.limit) || 20,
                        total: Number(data.total) || 0
                    }
                }
            };
        }

        default:
            return state;
    }
}
